module.exports = __webpack_public_path__ + "img/ic_qmarker_tank_lbl_issue.d34a5104.png";